import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { MyIcon } from "../../common/baseConfig";
import { Popover } from 'antd';
import { withRouter } from "react-router-dom";
export class FeedBackModal extends Component {
    static propTypes = {
        common: PropTypes.object.isRequired,
        actions: PropTypes.object.isRequired,
    };
    state = {
        showIndex: -1,
        showBackTop: false,
    }
    componentWillMount() {
        window.addEventListener('scroll', this.handleScroll.bind(this), true);
    }
    shouldComponentUpdate(nextProps, nextState) {
        const { fetchGetWeAppCodeSuccess, PublicData } = nextProps.common;
        if (fetchGetWeAppCodeSuccess && PublicData) {
            return true;
        }
        if (nextState.showIndex !== this.state.showIndex) {
            return true;
        }
        if (nextState.showBackTop === this.state.showBackTop) {
            return false;
        }
        return true;
    }
    handleScroll() {
        let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
        this.setState({
            showBackTop: scrollTop > 580
        })
    }
    onShowIndex(index) {
        this.setState({
            showIndex: index
        })
    }
    backTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }
    render() {
        const { showIndex, showBackTop } = this.state;
        const { fetchGetWeAppCodeSuccess, PublicData } = this.props.common;
        const smallProgramContent = (
            <div className="feed_back_popover_content">
                {fetchGetWeAppCodeSuccess && <img src={fetchGetWeAppCodeSuccess.Message} alt="" />}
                <p>扫描二维码进入小程序</p>
            </div>
        )
        const publicNumContent = (
            <div className="feed_back_popover_content">
                {PublicData && <img src={PublicData.Url} alt="" />}
                <p>扫描二维码关注公众号</p>
            </div>
        )
        return (
            <div className='feed_back'>

                <div className="feed_back_wrap" onMouseLeave={() => {
                    this.onShowIndex(-1)
                }}>
                    <div className="feed_back_item step7"
                        onMouseEnter={() => {
                            this.onShowIndex(0)
                        }}
                        onClick={() => this.props.history.push('/feedback')}>
                        <MyIcon className="feed_back_icon" type="iconbianji" />
                        <p>意见反馈</p>
                    </div>
                    <div className="feed_back_item"
                        onMouseEnter={() => {
                            this.onShowIndex(1)
                        }}
                        onClick={() => {
                            window._MEIQIA('showPanel');
                        }}>
                        <MyIcon className="feed_back_icon" type="iconkefu2" />
                        <p>联系客服</p>
                    </div>
                    <Popover
                        trigger="hover"
                        placement="left"
                        content={publicNumContent}
                    >
                        {PublicData && PublicData.Valid === 1 && <div className="feed_back_item"
                            onMouseEnter={() => {
                                this.onShowIndex(2)
                            }}
                        >
                            <MyIcon className="feed_back_icon" type="iconweixingongzhonghao2" />
                            <p>关注微信</p> 
                        </div>}
                    </Popover>
                    <Popover
                        trigger="hover"
                        placement="left"
                        content={smallProgramContent}
                    >
                        {fetchGetWeAppCodeSuccess && !fetchGetWeAppCodeSuccess.Data &&
                            <div
                                className="feed_back_item"
                                onMouseEnter={() => {
                                    this.onShowIndex(3)
                                }}
                        >
                            <MyIcon className="feed_back_icon" type="iconxiaochengxu1" />
                                <p>小程序码</p>
                            </div>
                        }
                    </Popover>
                    {
                        showBackTop && <div className="feed_back_item" onClick={() => this.backTop()} onMouseEnter={() => {
                            this.onShowIndex(4)
                        }}>
                            <MyIcon className="feed_back_icon" type="icontubiao02" />
                            <p>回到顶部</p>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

/* istanbul ignore next */
function mapStateToProps(state) {
    return {
        common: state.common,
    };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({ ...actions }, dispatch)
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(FeedBackModal));



// WEBPACK FOOTER //
// ./src/features/common/FeedBackModal.js